/* ===========================================================================
   Parfüm Sihirbazı
   ---------------------------------------------------------------------------
   Akış: hero -> 1. parfüm -> 2. parfüm -> 3. parfüm (opsiyonel) -> onay
         -> karıştırma -> sonuç

   Ürünler /products.json'dan yükleniyor. Liquid'de collection.products
   döngüsü sayfa başına 50 ürünle sınırlı olduğu için sunucuda basmak
   219 parfümün yalnızca 50'sini seçilebilir kılıyordu.

   Karıştırma animasyonu Canvas 2D; kütüphane yok. Tuval yalnızca o adıma
   geçilince kuruluyor, ilk boyamayı geciktirmiyor.
   =========================================================================== */
(function () {
  'use strict';

  var kok = document.querySelector('[data-psh-root]');
  if (!kok) return;

  var UC = kok.dataset.endpoint;
  var KARISIM_HANDLE = kok.dataset.karisimHandle;
  /* Virgulle ayrilmis etiket listesi. Bu etiketlerden birini tasiyan urun
     sihirbazda hic gorunmez: ne izgarada, ne aramada, ne populer/gecmis
     seritlerinde, ne de paylasilan karisim linkinde. */
  var HARIC_ETIKETLER = (kok.dataset.haricEtiket || '').split(',')
    .map(function (e) { return e.trim(); })
    .filter(Boolean);
  function haricMi(etiketler) {
    return (etiketler || []).some(function (e) { return HARIC_ETIKETLER.indexOf(e) !== -1; });
  }
  var EN_AZ = parseInt(kok.dataset.min, 10) || 2;
  var EN_COK = parseInt(kok.dataset.max, 10) || 3;

  /* Anahtar SÜRÜMLÜ. 3 parfüm seçeneği kaldırıldığında sunucudaki eski
     karışımlar silindi, ama ziyaretçilerin tarayıcısındaki liste yerinde
     kalıyordu: tıklayan kişi artık üretilemeyen 3 parfümlü bir karışım
     görürdü. Sürüm artınca eski kayıtlar okunmaz olur, temiz başlar. */
  var GECMIS_ANAHTAR = 'psh:gecmis:v2';
  var ZIYARETCI_ANAHTAR = 'psh:ziyaretci';
  var GECMIS_SINIR = 12;

  var sadeMod =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    getComputedStyle(kok).getPropertyValue('--psh-yogunluk').trim() === '0';
  if (sadeMod) kok.dataset.hareket = 'kapali';

  /* Tam genişlik hesabı için dikey kaydırma çubuğunun GERÇEK genişliği.
     100vw çubuğu da sayıyor; çıkarmazsak sayfa görünür alandan geniş kalıp
     yatay kaydırma çubuğu üretiyor. */
  function kaydirmaGenisligiOlc() {
    var fark = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--psh-sb', (fark > 0 ? fark : 0) + 'px');
  }
  kaydirmaGenisligiOlc();
  window.addEventListener('resize', kaydirmaGenisligiOlc);

  var ADIM_METNI = [
    { baslik: 'Birinci parfümünü seç', alt: 'Karışımın omurgasını kuracak kokuyu seç.' },
    { baslik: 'İkinci parfümünü seç', alt: 'Birincisiyle konuşacak, onu tamamlayacak kokuyu ekle.' },
  ];

  /* ------------------------------------------------------------- DEPOLAMA */

  function oku(anahtar, varsayilan) {
    try {
      var ham = window.localStorage.getItem(anahtar);
      return ham ? JSON.parse(ham) : varsayilan;
    } catch (e) { return varsayilan; }
  }

  function yaz(anahtar, deger) {
    try { window.localStorage.setItem(anahtar, JSON.stringify(deger)); } catch (e) { /* yok say */ }
  }

  function ziyaretciId() {
    var mevcut = oku(ZIYARETCI_ANAHTAR, null);
    if (mevcut) return mevcut;
    var yeni = window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : 'psh-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    yaz(ZIYARETCI_ANAHTAR, yeni);
    return yeni;
  }

  /* ----------------------------------------------------------------- DURUM */

  var urunler = [];
  var secilenler = [];
  var adim = 0;
  var sonSonuc = null;
  var karisimUrunu = null;
  var secilenVaryant = null;
  var animasyonDur = null;

  var el = {};
  function q(ad) { return kok.querySelector('[data-psh-' + ad + ']'); }

  ['raf', 'ara', 'ara-temizle', 'gorunen', 'bos', 'yukleniyor', 'izgara', 'kaydir',
   'durum', 'ileri', 'ileri-yazi', 'geri', 'adimlar', 'adim-no', 'adim-baslik', 'adim-alt',
   'basla', 'onay-liste', 'karistir', 'onay-geri', 'tuval', 'lab-metin', 'yedek',
   'ad', 'icerik', 'puanlar', 'yorum', 'hacim', 'sepete', 'yeniden', 'hata',
   'gecmis', 'gecmis-liste', 'populer', 'populer-liste', 'tarif'].forEach(function (ad) {
    el[ad.replace(/-(\w)/g, function (_, c) { return c.toUpperCase(); })] = q(ad);
  });

  /* Seritler hem giriste hem sonuc ekraninda var; ikisi de doluyor. */
  el.gecmisBolumleri = Array.prototype.slice.call(kok.querySelectorAll('[data-psh-gecmis]'));
  el.gecmisListeleri = Array.prototype.slice.call(kok.querySelectorAll('[data-psh-gecmis-liste]'));
  el.populerBolumleri = Array.prototype.slice.call(kok.querySelectorAll('[data-psh-populer]'));
  el.populerListeleri = Array.prototype.slice.call(kok.querySelectorAll('[data-psh-populer-liste]'));
  el.yuvalar = Array.prototype.slice.call(kok.querySelectorAll('[data-psh-yuva]'));
  el.noktalar = Array.prototype.slice.call(kok.querySelectorAll('[data-psh-nokta]'));
  el.filtreler = Array.prototype.slice.call(kok.querySelectorAll('[data-psh-filtre]'));
  el.basliklar = kok.querySelector('.psh-secim__basliklar');
  el.lab = kok.querySelector('.psh-lab');

  var ekranlar = {};
  kok.querySelectorAll('[data-psh-ekran]').forEach(function (e) { ekranlar[e.dataset.pshEkran] = e; });

  function ekranaGec(ad) {
    if (ad !== 'sonuc') urlTemizle();
    Object.keys(ekranlar).forEach(function (k) {
      ekranlar[k].hidden = k !== ad;
      ekranlar[k].classList.remove('psh-girer');
    });
    var hedef = ekranlar[ad];
    if (hedef && !sadeMod) { void hedef.offsetWidth; hedef.classList.add('psh-girer'); }

    /* Adım ekranları tam ekran katman; açıkken arkadaki sayfanın kaymasını
       kilitliyoruz. Sonuç ekranı akışta kalır ve normal kaydırılır. */
    var katman = hedef && hedef.classList.contains('psh-tam');
    document.documentElement.style.overflow = katman ? 'hidden' : '';
    document.body.style.overflow = katman ? 'hidden' : '';

    if (hedef && !katman) hedef.scrollIntoView({ behavior: sadeMod ? 'auto' : 'smooth', block: 'start' });
    if (katman) window.scrollTo(0, 0);
  }

  /* ------------------------------------------------------- ÜRÜNLERİ YÜKLE */

  function metinTemizle(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return (d.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 400);
  }

  function urunleriYukle() {
    return fetch('/collections/all/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (govde) {
        urunler = (govde.products || [])
          .filter(function (u) {
            if (KARISIM_HANDLE && u.handle === KARISIM_HANDLE) return false;
            if (haricMi(u.tags)) return false;
            return true;
          })
          .map(function (u) {
            var g = (u.images && u.images[0] && u.images[0].src) || '';
            return {
              id: String(u.id),
              ad: u.title,
              tip: u.product_type || '',
              etiketler: u.tags || [],
              /* Muadili olunan orijinal parfum MARKA alaninda duruyor
                 ("Inizio Rehability" -> "Initio Rehab"). Magazanin kendi
                 aramasi da bunu kullaniyor: "invictus" yazan "Champion"u
                 buluyor. Sihirbaz aramasi da ayni davranmali. */
              marka: u.vendor || '',
              aciklama: metinTemizle(u.body_html),
              gorsel: g ? g.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '',
            };
          });
        izgarayiCiz();
        populeriYukle();
        urldenGeriYukle();
      })
      .catch(function () {
        el.yukleniyor.textContent = 'Parfümler yüklenemedi. Sayfayı yenile.';
      });
  }

  function izgarayiCiz() {
    var parca = document.createDocumentFragment();
    urunler.forEach(function (u) {
      var li = document.createElement('li');
      li.className = 'psh-hucre';
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'psh-kart';
      d.dataset.id = u.id;
      d.setAttribute('aria-pressed', 'false');
      d.innerHTML =
        '<span class="psh-kart__gorsel">' +
        (u.gorsel ? '<img src="' + u.gorsel + '" alt="" loading="lazy" decoding="async">' : '') +
        '<span class="psh-kart__isaret" aria-hidden="true">&#10003;</span></span>' +
        '<span class="psh-kart__bilgi"><span class="psh-kart__ad"></span>' +
        '<span class="psh-kart__tip"></span></span>';
      d.querySelector('.psh-kart__ad').textContent = u.ad;
      d.querySelector('.psh-kart__tip').textContent =
        u.etiketler.indexOf('Unisex Parfüm') !== -1 ? 'Unisex Parfüm' : u.tip;
      d.addEventListener('click', function () { kartSecildi(u); });
      li.appendChild(d);
      parca.appendChild(li);
    });
    el.izgara.innerHTML = '';
    el.izgara.appendChild(parca);
    el.izgara.setAttribute('aria-busy', 'false');
    el.yukleniyor.hidden = true;
    suz();
  }

  /* ------------------------------------------------------------ ADIM AKIŞI

     secilenler DELİKSİZ bir dizidir. Daha önce boş bırakılan indeksler
     tutuluyordu; kullanıcı 1. parfümü silince dizi [boş, X, Y] kalıyor ve
     akış 2. adımdan başlıyordu. Silme artık splice ile boşluğu kapatıyor,
     imleç de kalan seçim sayısına göre yeniden hesaplanıyor. */

  function imleciDuzelt() {
    adim = Math.min(secilenler.length, EN_COK - 1);
  }

  function adimiCiz() {
    var m = ADIM_METNI[adim];
    el.adimNo.textContent = '0' + (adim + 1);
    el.adimBaslik.textContent = m.baslik;
    el.adimAlt.textContent = m.alt;

    if (!sadeMod && el.basliklar) {
      el.basliklar.classList.remove('is-degisti');
      void el.basliklar.offsetWidth;
      el.basliklar.classList.add('is-degisti');
    }

    el.noktalar.forEach(function (n, i) {
      n.classList.toggle('is-tamam', !!secilenler[i]);
      n.classList.toggle('is-aktif', i === adim && !secilenler[i]);
    });

    var secili = secilenler[adim];
    var sonAdim = adim === EN_COK - 1;
    var yeterli = secilenler.length >= EN_AZ;

    /* "ATLA" yalnızca son adım GERÇEKTEN opsiyonelse anlamlı. En az ve en çok
       seçim eşitken (2/2) atlanacak bir şey yok; o etiketi göstermek
       ziyaretçiye olmayan bir seçenek vaat ederdi. */
    var sonAdimOpsiyonel = sonAdim && EN_AZ < EN_COK;
    el.ileriYazi.textContent = sonAdimOpsiyonel && !secili ? 'ATLA' : 'DEVAM';
    el.ileri.disabled = sonAdim ? !yeterli : !secili;

    el.durum.textContent = secili
      ? secili.ad + ' seçildi'
      : sonAdim
        ? (yeterli ? 'İstersen bu adımı atlayabilirsin' : 'En az ' + EN_AZ + ' parfüm gerekiyor')
        : 'Listeden bir parfüm seç';


    Array.prototype.forEach.call(el.izgara.children, function (li) {
      var d = li.firstElementChild;
      if (!d) return;
      var sira = secilenler.findIndex(function (s) { return s && s.id === d.dataset.id; });
      d.setAttribute('aria-pressed', sira !== -1 ? 'true' : 'false');
      d.disabled = false;
      var rozet = d.querySelector('.psh-kart__isaret');
      if (rozet) rozet.textContent = sira !== -1 ? String(sira + 1) : '';
    });

    rafiCiz();
  }

  function rafiCiz() {
    el.yuvalar.forEach(function (yuva, i) {
      var u = secilenler[i];
      yuva.classList.toggle('is-dolu', !!u);
      yuva.classList.toggle('is-hedef', i === adim);
      if (!u) {
        yuva.innerHTML =
          '<span class="psh-secili__no">0' + (i + 1) + '</span>' +
          (i === 2 ? '<span class="psh-secili__not">opsiyonel</span>' : '');
        delete yuva.dataset.dolu;
        return;
      }
      if (yuva.dataset.dolu === u.id) return;
      yuva.dataset.dolu = u.id;
      yuva.innerHTML =
        '<span class="psh-secili__no">0' + (i + 1) + '</span>' +
        (u.gorsel ? '<img class="psh-secili__gorsel" src="' + u.gorsel + '" alt="">' : '') +
        '<span class="psh-secili__ad"></span>' +
        '<button type="button" class="psh-secili__kaldir" aria-label="Kaldır">&times;</button>';
      yuva.querySelector('.psh-secili__ad').textContent = u.ad;
      yuva.querySelector('.psh-secili__kaldir').addEventListener('click', function (ev) {
        ev.stopPropagation();
        secimiKaldir(u.id);
      });
      if (!sadeMod) {
        yuva.classList.add('is-yeni');
        setTimeout(function () { yuva.classList.remove('is-yeni'); }, 460);
      }
    });
  }

  function secimiKaldir(id) {
    var i = secilenler.findIndex(function (s) { return s && s.id === id; });
    if (i === -1) return;
    secilenler.splice(i, 1);   /* boşluk bırakma: sonrakiler yukarı kayar */
    imleciDuzelt();
    adimiCiz();
  }

  function kartSecildi(urun) {
    /* Seçili bir karta tekrar tıklamak seçimi kaldırır */
    var mevcut = secilenler.findIndex(function (s) { return s && s.id === urun.id; });
    if (mevcut !== -1) { secimiKaldir(urun.id); return; }

    if (adim < secilenler.length) secilenler[adim] = urun;
    else if (secilenler.length < EN_COK) secilenler.push(urun);
    else return;

    var sonAdimdaydi = adim >= EN_COK - 1;
    imleciDuzelt();
    adimiCiz();

    /* Sıradaki adıma kendiliğinden geç; son adımda kullanıcıyı bekletme */
    if (!sonAdimdaydi && secilenler.length < EN_COK) {
      setTimeout(function () { el.kaydir.scrollTop = 0; }, sadeMod ? 0 : 420);
    }
  }

  function ileriGit() {
    if (adim < EN_COK - 1 && secilenler[adim]) {
      adim++;
      adimiCiz();
      el.kaydir.scrollTop = 0;
      return;
    }
    if (secilenler.length < EN_AZ) {
      el.durum.textContent = 'En az ' + EN_AZ + ' parfüm gerekiyor';
      return;
    }
    onayaGec();
  }

  function onayaGec() {
    onayiCiz();
    ekranaGec('onay');
  }

  function geriGit() {
    if (adim === 0) { ekranaGec('hero'); return; }
    adim--;
    adimiCiz();
    el.kaydir.scrollTop = 0;
  }

  /* ------------------------------------------------------------------ ONAY */

  function onayiCiz() {
    var liste = secilenler.filter(Boolean);
    el.onayListe.innerHTML = '';
    liste.forEach(function (u, i) {
      if (i > 0) {
        var arti = document.createElement('li');
        arti.className = 'psh-onay__arti';
        arti.setAttribute('aria-hidden', 'true');
        arti.textContent = '+';
        el.onayListe.appendChild(arti);
      }
      var li = document.createElement('li');
      li.className = 'psh-onay__kart';
      li.style.setProperty('--i', i);
      li.innerHTML =
        (u.gorsel ? '<img class="psh-onay__gorsel" src="' + u.gorsel + '" alt="">' : '') +
        '<span class="psh-onay__bilgi"><span class="psh-onay__no">PARFÜM 0' + (i + 1) + '</span>' +
        '<span class="psh-onay__ad"></span></span>';
      li.querySelector('.psh-onay__ad').textContent = u.ad;
      el.onayListe.appendChild(li);
    });
  }

  /* --------------------------------------------------------- ARAMA/FİLTRE */

  var aktifFiltre = '';
  var aramaMetni = '';

  function normalize(s) {
    return (s || '').toLocaleLowerCase('tr')
      .replace(/ı/g, 'i').replace(/İ/g, 'i').replace(/ş/g, 's')
      .replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c');
  }

  function suz() {
    var s = normalize(aramaMetni).trim();
    var gorunen = 0;
    Array.prototype.forEach.call(el.izgara.children, function (li, i) {
      var u = urunler[i];
      if (!u) return;
      var etiketUyar = !aktifFiltre || (u.etiketler || []).indexOf(aktifFiltre) !== -1;
      /* Isim VEYA marka eslesmesi: ziyaretci "invictus" arayip "Champion"u
         bulabilmeli. Arama metni her tuslamada degil, urun basina bir kez
         normalize ediliyor (u.arama onbellegi). */
      if (u.arama === undefined) u.arama = normalize(u.ad) + ' | ' + normalize(u.marka);
      var goster = (!s || u.arama.indexOf(s) !== -1) && etiketUyar;
      li.hidden = !goster;
      if (goster) gorunen++;
    });
    el.gorunen.textContent = gorunen;
    el.bos.hidden = gorunen !== 0 || !urunler.length;
  }

  var aramaZaman;
  el.ara.addEventListener('input', function () {
    aramaMetni = el.ara.value;
    el.araTemizle.hidden = !aramaMetni;
    clearTimeout(aramaZaman);
    aramaZaman = setTimeout(suz, 110);
  });

  el.araTemizle.addEventListener('click', function () {
    el.ara.value = '';
    aramaMetni = '';
    el.araTemizle.hidden = true;
    suz();
    el.ara.focus();
  });

  el.filtreler.forEach(function (d) {
    d.addEventListener('click', function () {
      aktifFiltre = d.dataset.pshFiltre;
      el.filtreler.forEach(function (x) { x.classList.toggle('is-aktif', x === d); });
      suz();
      el.kaydir.scrollTop = 0;
    });
  });

  /* ------------------------------------------------------------- ANİMASYON */

  function tonTuret(id) {
    var h = 0;
    for (var i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) % 360;
    return h;
  }

  function renkOrnekle(urun) {
    var yedek = 'hsl(' + tonTuret(urun.id) + ', 62%, 58%)';
    if (!urun.gorsel) return Promise.resolve(yedek);
    return new Promise(function (coz) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = c.height = 12;
          var x = c.getContext('2d');
          x.drawImage(img, 0, 0, 12, 12);
          var d = x.getImageData(0, 0, 12, 12).data;
          var r = 0, g = 0, b = 0, n = 0;
          for (var i = 0; i < d.length; i += 4) {
            if (d[i + 3] < 40) continue;
            r += d[i]; g += d[i + 1]; b += d[i + 2]; n++;
          }
          coz(n ? 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')' : yedek);
        } catch (e) { coz(yedek); }
      };
      img.onerror = function () { coz(yedek); };
      img.src = urun.gorsel;
    });
  }

  function animasyonBaslat(liste) {
    if (sadeMod || !el.tuval || !el.tuval.getContext) {
      el.lab.classList.add('is-yedek');
      return function () {};
    }
    var ctx = el.tuval.getContext('2d');
    var olcek = Math.min(window.devicePixelRatio || 1, 2);
    var boyut = el.tuval.clientWidth || 520;
    el.tuval.width = el.tuval.height = boyut * olcek;
    ctx.scale(olcek, olcek);

    var kureler = liste.map(function (u, i) {
      return {
        aci: (i / liste.length) * Math.PI * 2,
        yaricap: boyut * 0.3,
        r: boyut * 0.15,
        renk: 'hsl(' + tonTuret(u.id) + ', 62%, 58%)',
        hiz: 0.85 + i * 0.14,
      };
    });

    Promise.all(liste.map(renkOrnekle)).then(function (renkler) {
      renkler.forEach(function (renk, i) { if (kureler[i]) kureler[i].renk = renk; });
    });

    /* Yorunge uzerinde donen ince parcaciklar: kurelerin etrafinda
       "buharlasan nota" hissi veriyor. Kurelerden ucuz, sayilari cihaz
       gucune gore degil sabit tutuldu (en fazla 3 kure x 14). */
    var parcaciklar = [];
    kureler.forEach(function (k, ki) {
      for (var i = 0; i < 14; i++) {
        parcaciklar.push({
          kure: ki,
          aci: Math.random() * Math.PI * 2,
          uzaklik: boyut * (0.05 + Math.random() * 0.12),
          hiz: 0.6 + Math.random() * 1.6,
          r: 1 + Math.random() * 2.2,
        });
      }
    });

    var t0 = performance.now();
    var kare = null;
    var duruyor = false;

    function ciz(zaman) {
      if (duruyor) return;
      var gecen = (zaman - t0) / 1000;
      var p = Math.min(gecen / 2.4, 1);
      var yumusak = p * p * (3 - 2 * p);

      ctx.clearRect(0, 0, boyut, boyut);

      /* Beyaz zeminde 'lighter' renkleri beyaza dogru yikiyordu; 'multiply'
         ayni renkleri murekkep gibi koyulastiriyor. */
      ctx.globalCompositeOperation = 'multiply';
      ctx.filter = 'blur(' + (24 - yumusak * 10) + 'px)';

      var merkezler = [];
      kureler.forEach(function (k) {
        var aci = k.aci + gecen * k.hiz;
        var mesafe = k.yaricap * (1 - yumusak);
        var x = boyut / 2 + Math.cos(aci) * mesafe;
        var y = boyut / 2 + Math.sin(aci) * mesafe;
        merkezler.push({ x: x, y: y });
        var r = k.r * (1 + yumusak * 0.45);
        var g = ctx.createRadialGradient(x, y, 0, x, y, r);
        g.addColorStop(0, k.renk);
        g.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(x, y, r, 0, Math.PI * 2);
        ctx.fill();
      });

      /* Parcaciklar: keskin, bulanik degil */
      ctx.filter = 'none';
      ctx.globalCompositeOperation = 'source-over';
      parcaciklar.forEach(function (pz) {
        var m = merkezler[pz.kure];
        if (!m) return;
        var a = pz.aci + gecen * pz.hiz;
        var x = m.x + Math.cos(a) * pz.uzaklik;
        var y = m.y + Math.sin(a) * pz.uzaklik;
        ctx.globalAlpha = 0.35 * (1 - yumusak * 0.5);
        ctx.fillStyle = kureler[pz.kure].renk;
        ctx.beginPath();
        ctx.arc(x, y, pz.r, 0, Math.PI * 2);
        ctx.fill();
      });
      ctx.globalAlpha = 1;

      /* Birlesme tamamlanirken disari acilan halka */
      if (yumusak > 0.55) {
        var hp = (yumusak - 0.55) / 0.45;
        ctx.strokeStyle = 'rgba(168, 17, 42, ' + (0.35 * (1 - hp)).toFixed(3) + ')';
        ctx.lineWidth = 1.5;
        ctx.beginPath();
        ctx.arc(boyut / 2, boyut / 2, boyut * (0.18 + hp * 0.3), 0, Math.PI * 2);
        ctx.stroke();
      }

      kare = requestAnimationFrame(ciz);
    }

    kare = requestAnimationFrame(ciz);

    var metinler = ['NOTALAR AYRIŞTIRILIYOR', 'KARIŞIM DENGELENİYOR', 'İMZA OLUŞTURULUYOR'];
    var mi = 0;
    var z = setInterval(function () {
      mi = (mi + 1) % metinler.length;
      el.labMetin.textContent = metinler[mi];
    }, 1150);

    return function () {
      duruyor = true;
      if (kare) cancelAnimationFrame(kare);
      clearInterval(z);
    };
  }

  /* ------------------------------------------------------------------- API */

  function karisimIste(liste) {
    return fetch(UC, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        ziyaretciId: ziyaretciId(),
        urunler: liste.map(function (u) {
          return { id: u.id, ad: u.ad, tip: u.tip, aciklama: (u.aciklama || '').slice(0, 400) };
        }),
      }),
    }).then(function (r) {
      return r.json().then(function (govde) {
        if (!r.ok) throw new Error((govde && (govde.message || govde.error)) || 'Servis yanıt vermedi (' + r.status + ')');
        var veri = govde && govde.data ? govde.data : govde;
        if (!veri || !veri.puanlar) throw new Error('Beklenmeyen yanıt biçimi');
        return veri;
      });
    });
  }

  /* -------------------------------------------------------------- SONUÇ */

  function adiYaz(metin) {
    el.ad.innerHTML = '';
    if (sadeMod) { el.ad.textContent = metin; return; }
    metin.split('').forEach(function (harf, i) {
      var s = document.createElement('span');
      s.className = 'psh-harf' + (harf === ' ' ? ' psh-harf--bosluk' : '');
      s.style.setProperty('--i', i);
      s.textContent = harf === ' ' ? ' ' : harf;
      el.ad.appendChild(s);
    });
  }

  /* Kalıcılık ve Yayılım ürün vaadi; yapay zekanın takdirine bırakılmıyor.
     Yayılım kategorisi modele hiç sorulmuyor, burada ekleniyor. */
  var SABIT_PUANLAR = { 'Kalıcılık': 10, 'Yayılım': 10 };

  function puanlariHazirla(ham) {
    var sonuc = {};
    Object.keys(ham || {}).forEach(function (k) {
      sonuc[k] = SABIT_PUANLAR[k] != null ? SABIT_PUANLAR[k] : ham[k];
    });
    Object.keys(SABIT_PUANLAR).forEach(function (k) {
      if (sonuc[k] == null) sonuc[k] = SABIT_PUANLAR[k];
    });
    return sonuc;
  }

  function puanlariCiz(ham) {
    var puanlar = puanlariHazirla(ham);
    el.puanlar.innerHTML = '';
    el.puanlar.classList.remove('is-cizili');
    Object.keys(puanlar).forEach(function (ad, i) {
      var deger = Math.max(0, Math.min(10, Number(puanlar[ad]) || 0));
      var satir = document.createElement('div');
      satir.className = 'psh-puan' + (deger >= 10 ? ' is-tam' : '');
      satir.innerHTML =
        '<span class="psh-puan__ad"></span><span class="psh-puan__deger">' + deger + '/10</span>' +
        '<span class="psh-puan__ray"><span class="psh-puan__dolgu"></span></span>';
      satir.querySelector('.psh-puan__ad').textContent = ad;
      var dolgu = satir.querySelector('.psh-puan__dolgu');
      dolgu.style.setProperty('--oran', deger * 10 + '%');
      dolgu.style.setProperty('--i', i);
      el.puanlar.appendChild(satir);
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.puanlar.classList.add('is-cizili'); });
    });
  }

  /* Sonuc adres cubuguna yaziliyor; sayfa yenilenince karisim kaybolmuyor
     ve link paylasilabiliyor. Geri tusu de dogal calisiyor. */
  function urlYaz(liste) {
    try {
      var anahtar = liste.map(function (u) { return u.id; }).join('-');
      var yeni = window.location.pathname + '?karisim=' + encodeURIComponent(anahtar);
      window.history.replaceState({ karisim: anahtar }, '', yeni);
    } catch (e) { /* tarayici izin vermiyorsa sessizce gec */ }
  }

  /* Sonuc ekranindan cikilinca adres cubugundaki karisim silinmeli.
     Kalirsa: kullanici "parfumleri degistir" deyip GERI tusuna basinca
     giris ekranina donuyor ama URL hala karisimi gosteriyor; sayfayi
     yenileyince o karisim geri aciliyordu. */
  function urlTemizle() {
    try {
      if (!window.location.search) return;
      window.history.replaceState({}, "", window.location.pathname);
    } catch (e) { /* tarayici izin vermiyorsa sessizce gec */ }
  }

  function urldenOku() {
    try {
      var p = new URLSearchParams(window.location.search).get('karisim');
      return p ? p.split('-').filter(Boolean) : null;
    } catch (e) { return null; }
  }

  function sonucuCiz(veri, liste) {
    sonSonuc = { veri: veri, urunler: liste };
    /* Eski gecmis kayitlari karisimAdi tasiyor; yeni sunucu kokuTarifi
       donduruyor. Ikisini de kabul ediyoruz ki localStorage temizlenmesin. */
    adiYaz(veri.karisimAdi || veri.kokuTarifi || "");
    /* Ad baslik, koku tarifi alt baslik. Eski kayitlarda tarif yok. */
    el.tarif.textContent = veri.kokuTarifi && veri.karisimAdi ? veri.kokuTarifi : "";
    el.icerik.textContent = liste.map(function (u) { return u.ad; }).join('  +  ');
    puanlariCiz(veri.puanlar || {});
    el.yorum.textContent = veri.yorum || '';
    el.hata.hidden = true;
    hacimleriCiz();
    urlYaz(liste);
    ekranaGec('sonuc');
  }

  function hacimleriCiz() {
    if (!karisimUrunu) {
      el.hacim.innerHTML = '<p class="psh-durum">Karışım ürünü yüklenemedi. Mağazanın birincil alan adından (parfumchef.com) deneyin.</p>';
      el.sepete.disabled = true;
      return;
    }
    el.hacim.innerHTML = '';
    secilenVaryant = null;
    karisimUrunu.variants.forEach(function (v) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'psh-hacim__d';
      d.disabled = !v.available;
      d.innerHTML = v.title + '<span class="psh-hacim__fiyat">' +
        (v.price / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' ₺</span>';
      d.addEventListener('click', function () {
        secilenVaryant = v;
        Array.prototype.forEach.call(el.hacim.children, function (c) { c.classList.remove('is-aktif'); });
        d.classList.add('is-aktif');
        el.sepete.disabled = false;
      });
      el.hacim.appendChild(d);
      if (v.available && !secilenVaryant) { secilenVaryant = v; d.classList.add('is-aktif'); }
    });
    el.sepete.disabled = !secilenVaryant;
  }

  /* Panel raporundaki "sepete eklendi" adimi.
     ATES ET VE UNUT: sonucu beklenmiyor, hatasi yutuluyor. Urun sepete
     zaten girdi; bir raporlama cagrisi yuzunden ziyaretciye hata gostermek
     ya da onu bekletmek anlamsiz olurdu.
     Tutar GONDERILMIYOR: ciro istemciden degil, Shopify'dan cekilen siparis
     satirlarindan hesaplaniyor. */
  function sepetOlayiBildir() {
    if (!UC || !sonSonuc) return;
    try {
      var uc = UC.replace(/\/karisim$/, '/olay');
      var anahtar = sonSonuc.urunler.map(function (u) { return u.id; }).sort().join(',');
      fetch(uc, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        keepalive: true,
        body: JSON.stringify({
          ziyaretciId: ziyaretciId(),
          urunAnahtari: anahtar,
          karisimAdi: sonSonuc.veri.karisimAdi || sonSonuc.veri.kokuTarifi || '',
          varyant: (secilenVaryant && secilenVaryant.title) || '',
        }),
      }).catch(function () { /* rapor kaydi ziyaretciyi etkilemez */ });
    } catch (e) { /* yok say */ }
  }

  function sepeteEkle() {
    if (!secilenVaryant || !sonSonuc) return;
    el.sepete.disabled = true;
    var yazi = el.sepete.querySelector('span');
    yazi.textContent = 'EKLENİYOR...';

    var ozellikler = { "Karışım Adı": sonSonuc.veri.karisimAdi || "-" };
    if (sonSonuc.veri.kokuTarifi) ozellikler["Koku Tarifi"] = sonSonuc.veri.kokuTarifi;
    sonSonuc.urunler.forEach(function (u, i) { ozellikler['Parfüm ' + (i + 1)] = u.ad; });
    /* Alt cizgili ozellik musteriye gorunmez, admin siparisinde gorunur.
       Amaci sepette satirlari ayirmak: aksi halde 100ml ekleyip sonra 50ml
       eklemek yeni satir yerine mevcut satiri gunceller gibi davraniyordu. */
    ozellikler['_kimlik'] = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

    /* Sepet bolumlerinin kimligi: tema bunlarin taze HTML'ini istiyor. */
    var bolumIdleri = [];
    document.querySelectorAll('cart-items-component').forEach(function (x) {
      if (x.dataset && x.dataset.sectionId) bolumIdleri.push(x.dataset.sectionId);
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: secilenVaryant.id, quantity: 1, properties: ozellikler }],
        sections: bolumIdleri.join(','),
      }),
    })
      .then(function (r) { if (!r.ok) throw new Error('Sepete eklenemedi'); return r.json(); })
      .then(function (eklendi) {
        yazi.textContent = 'SEPETE EKLENDİ';
        sepetOlayiBildir();
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (sepet) {
            /* Temanin sepet bileseni bu govdeyi bekliyor; sadece bos bir
               CustomEvent gondermek sayaci guncellemiyordu. */
            var olay = new Event('cart:update', { bubbles: true });
            olay.detail = {
              resource: sepet,
              sourceId: 'parfum-sihirbazi',
              data: {
                source: 'parfum-sihirbazi',
                itemCount: sepet.item_count,
                sections: (eklendi && eklendi.sections) || {},
              },
            };
            document.dispatchEvent(olay);
          });
        setTimeout(function () { yazi.textContent = 'SEPETE EKLE'; el.sepete.disabled = false; }, 2400);
      })
      .catch(function (e) {
        el.hata.textContent = e.message;
        el.hata.hidden = false;
        yazi.textContent = 'SEPETE EKLE';
        el.sepete.disabled = false;
      });
  }

  /* --------------------------------------------------------------- GEÇMİŞ */

  function gecmiseYaz(veri, liste) {
    var kayitlar = oku(GECMIS_ANAHTAR, []);
    var anahtar = liste.map(function (u) { return u.id; }).sort().join(',');
    kayitlar = kayitlar.filter(function (k) { return k.anahtar !== anahtar; });
    kayitlar.unshift({ anahtar: anahtar, veri: veri, urunler: liste, tarih: Date.now() });
    yaz(GECMIS_ANAHTAR, kayitlar.slice(0, GECMIS_SINIR));
    gecmisiCiz();
  }

  function serideKartEkle(liste, kayit, meta) {
    var li = document.createElement('li');
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'psh-serit__kart';

    var gorseller = document.createElement('span');
    gorseller.className = 'psh-serit__gorseller';
    kayit.urunler.slice(0, 3).forEach(function (u) {
      if (!u.gorsel) return;
      var img = document.createElement('img');
      img.className = 'psh-serit__gorsel';
      img.src = u.gorsel;
      img.alt = '';
      img.loading = 'lazy';
      gorseller.appendChild(img);
    });

    var ad = document.createElement('span');
    ad.className = 'psh-serit__ad';
    ad.textContent = kayit.veri.karisimAdi || kayit.veri.kokuTarifi || "";

    var alt = document.createElement('span');
    alt.className = 'psh-serit__meta';
    alt.innerHTML = meta || '';

    d.appendChild(gorseller);
    d.appendChild(ad);
    d.appendChild(alt);
    /* Seritten cizim sunucuya GITMEZ, kota yakmaz */
    d.addEventListener('click', function () { sonucuCiz(kayit.veri, kayit.urunler); });
    li.appendChild(d);
    liste.appendChild(li);
  }

  function gecmisiCiz() {
    /* Sonradan haric tutulan bir urunu iceren eski kayitlar da gosterilmez. */
    var kayitlar = oku(GECMIS_ANAHTAR, []).filter(function (k) {
      return !k.urunler.some(function (u) { return haricMi(u.etiketler); });
    });
    el.gecmisBolumleri.forEach(function (b) { b.hidden = kayitlar.length === 0; });
    el.gecmisListeleri.forEach(function (liste) {
      liste.innerHTML = '';
      kayitlar.forEach(function (kayit) {
        var adlar = kayit.urunler.map(function (u) { return u.ad; }).join(' + ');
        serideKartEkle(liste, kayit, adlar);
      });
    });
  }

  /* EN COK OLUSTURULANLAR: magaza geneli, STools ucundan.
     Uc henuz yayinda degilse ya da kayit yoksa serit gizli kalir; sayfanin
     geri kalani bundan etkilenmez. */
  function populeriYukle() {
    var uc = UC.replace(/\/karisim$/, '/populer');
    fetch(uc + '?limit=12', { credentials: 'include' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (govde) {
        var kayitlar = govde && govde.success && Array.isArray(govde.data) ? govde.data : [];
        if (!kayitlar.length) return;
        el.populerListeleri.forEach(function (x) { x.innerHTML = ''; });
        var eklendi = 0;
        kayitlar.forEach(function (k) {
          var secilen = (k.urunIdleri || [])
            .map(function (id) {
              return urunler.filter(function (u) { return u.id === String(id); })[0];
            })
            .filter(Boolean);
          /* Urun silinmis/gizlenmisse o karisimi hic gosterme */
          if (secilen.length < 2) return;
          el.populerListeleri.forEach(function (liste) { serideKartEkle(
            liste,
            /* Puan ve yorum SUNUCUDAN geliyor. Once boş gonderiliyordu ve
               karta tiklayan ziyaretci bos bir sonuc ekrani goruyordu:
               puan kalmayinca yalnizca her karisimda sabit olan
               Kalicilik/Yayilim 10/10 satirlari ciziliyor, yorum da bos
               kaliyordu. Veri zaten onbellekte duruyordu, uc atiyordu. */
            {
              veri: {
                karisimAdi: k.karisimAdi || k.kokuTarifi,
                kokuTarifi: k.kokuTarifi || '',
                puanlar: k.puanlar || {},
                yorum: k.yorum || '',
              },
              urunler: secilen,
            },
            '<span class="psh-serit__rozet">' + (k.kez || 1) + ' kez</span>'
          ); });
          eklendi++;
        });
        el.populerBolumleri.forEach(function (b) { b.hidden = eklendi === 0; });
      })
      .catch(function () { /* serit gizli kalir */ });
  }

  /* Serit oklari */
  kok.querySelectorAll('[data-psh-kaydir-geri],[data-psh-kaydir-ileri]').forEach(function (d) {
    d.addEventListener('click', function () {
      var hedefAd = d.dataset.pshKaydirGeri || d.dataset.pshKaydirIleri;
      var yon = d.dataset.pshKaydirGeri ? -1 : 1;
      var bolum = d.closest('.psh-serit');
      var liste = bolum ? bolum.querySelector('.psh-serit__liste') : null;
      if (liste) liste.scrollBy({ left: yon * Math.round(liste.clientWidth * 0.8), behavior: 'smooth' });
    });
  });

  /* ------------------------------------------------------------------ AKIŞ */

  el.basla.addEventListener('click', function () {
    ekranaGec('secim');
    adim = 0;
    adimiCiz();
  });

  el.ileri.addEventListener('click', ileriGit);
  el.geri.addEventListener('click', geriGit);
  el.onayGeri.addEventListener('click', function () {
    ekranaGec('secim');
    adim = 0;
    adimiCiz();
  });

  el.karistir.addEventListener('click', function () {
    var liste = secilenler.filter(Boolean);
    if (liste.length < EN_AZ) return;

    /* Katman: onay ekrani ARKADA gorunur kaliyor, karisim secilen
       urunlerin uzerinde oluyormus gibi okunuyor. */
    ekranlar.karistir.hidden = false;
    ekranlar.onay.classList.add('is-karisiyor');
    if (!sadeMod) { void ekranlar.karistir.offsetWidth; ekranlar.karistir.classList.add('psh-girer'); }
    animasyonDur = animasyonBaslat(liste);

    var enAz = new Promise(function (coz) { setTimeout(coz, sadeMod ? 0 : 2400); });

    Promise.all([karisimIste(liste), enAz])
      .then(function (s) {
        if (animasyonDur) animasyonDur();
        ekranlar.karistir.hidden = true;
        ekranlar.onay.classList.remove('is-karisiyor');
        sonucuCiz(s[0], liste);
        gecmiseYaz(s[0], liste);
      })
      .catch(function (e) {
        if (animasyonDur) animasyonDur();
        ekranlar.karistir.hidden = true;
        ekranlar.onay.classList.remove('is-karisiyor');
        ekranaGec('onay');
        var uyari = document.createElement('p');
        uyari.className = 'psh-hata';
        uyari.textContent = e.message || 'Karışım oluşturulamadı';
        var eski = el.onayListe.parentElement.querySelector('.psh-hata');
        if (eski) eski.remove();
        el.onayListe.parentElement.appendChild(uyari);
      });
  });

  el.yeniden.addEventListener('click', function () {
    ekranaGec('secim');
    adim = 0;
    adimiCiz();
  });

  el.sepete.addEventListener('click', sepeteEkle);

  /* Adres cubugundaki karisimi geri getir: once yerel gecmisten (aninda,
     sunucuya gitmez), yoksa uctan. Uctan gelse bile ayni urun kumesi
     onbellekte oldugu icin kota yakmaz. */
  function urldenGeriYukle() {
    var idler = urldenOku();
    if (!idler || idler.length < EN_AZ) return;

    /* Once listede olup olmadiklarina bakiliyor: haric tutulan bir urunun
       linki yerel gecmiste kayitli olsa bile acilmamali. */
    var secilen = idler
      .map(function (id) { return urunler.filter(function (u) { return u.id === String(id); })[0]; })
      .filter(Boolean);
    if (secilen.length < EN_AZ) return;

    var kayitlar = oku(GECMIS_ANAHTAR, []);
    var anahtar = idler.slice().sort().join(',');
    var yerel = kayitlar.filter(function (k) { return k.anahtar === anahtar; })[0];
    if (yerel) { sonucuCiz(yerel.veri, yerel.urunler); return; }

    karisimIste(secilen)
      .then(function (veri) { sonucuCiz(veri, secilen); gecmiseYaz(veri, secilen); })
      .catch(function () { /* baslangic ekraninda kal */ });
  }

  /* ------------------------------------------------------------- BAŞLANGIÇ */

  if (KARISIM_HANDLE) {
    fetch('/products/' + KARISIM_HANDLE + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (u) { karisimUrunu = u; })
      .catch(function () { /* hacimleriCiz uyarıyı gösterir */ });
  }

  urunleriYukle();
  adimiCiz();
  gecmisiCiz();
})();
